import CloseIcon from "@mui/icons-material/Close";
import DownloadIcon from "@mui/icons-material/DownloadOutlined";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import FilterListIcon from "@mui/icons-material/FilterList";
import { Dialog, DialogContent, DialogTitle, FormLabel, Grid, IconButton, Stack, TextareaAutosize, TextField, Table, TableBody, TableCell, TableHead, TableRow, Typography, Box } from "@mui/material";
import { DataGrid, GridToolbarContainer } from "@mui/x-data-grid";
import format from "date-fns/format";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { getCashTracker, getCashTrackerReport } from "../../Services/api";
import { NAVIGATION_PAGE_NAME } from "../../constants";
import instance from "../../redux/api";
import {
  getAccountsList,
  getBrokerBranchesList,
  getCurrencyList,
} from "../../redux/slice/bankStatmentTransactionsSlice";
import { allocationStatusList } from "../CashAllocation/constants";
import { customDateFormat, getPaginationCount } from "../CashAllocation/utils";
import { useStyles } from "../bankTransactions/bankTranscationContainerStyles";
import { CommonPaginationContainer, CommonSelect, CommonFilterSidebar } from "../common";
import CustomDateRangePicker from "../common/CustomDateRangePicker";
import { CommonButton } from "../common/commonButton";
import { ViewAndEditBankTransaction } from "./ViewAndEditTxnDialog";
import { numberFormatter } from "../../utils/generalFunctions";
import { commonToast } from "../common";
import "../common/commonPageStyles.css";

//styles
const CashTrackerText = {
  display: "flex",
  justifyContent: "space-between",
  fontWeight: "400",
  marginTop: 5,
};

export default function CashTracker() {
  const { search } = useLocation();

  const toggle = useSelector((state) => state.toggleSideMenu);

  const dispatch = useDispatch();
  const location = useLocation();
  // const navigate = useNavigate();

  // const [searchText, setSearchText] = useState("");
  // const [tableRows, setTableRows] = useState([]);
  // const [filteredRows, setFilteredRows] = useState(tableRows);
  const [currentRow, setCurrentRow] = useState("");
  const [txnMode, setTxnMode] = useState("VIEW");
  const [isOpenTxnDialog, setIsOpenTxnDialog] = useState(false);

  const [fromDateValue, setFromDateValue] = useState("");
  const [toDateValue, setToDateValue] = useState("");
  const [isDownloadInProgress, setIsDownloadInProgress] = useState(false);
  const [totalTransactionAmount, setTotalTransactionAmount] = useState(false);

  // Summary States
  const [totalPremiumDueAmount, setTotalPremiumDueAmount] = useState(0);
  const [totalAllocatedAmount, setTotalAllocatedAmount] = useState(0);
  const [totalreceivableAmount, setTotalreceivableAmount] = useState(0);
  const [bankTxnAmount, setBankTxnAmount] = useState(0);
  const [outstandingAmount, setOutstandingAmount] = useState(0);
  const [receivableAmount, setReceivableAmount] = useState();
  const [variance, setVariance] = useState();

  //styles
  const classes = useStyles();

  const [searchFieldsPrams, setSearchFieldsPrams] = useState({
    Bank_Name: "",
    Bank_Policy_No: "",
    allocated_date: "",
    Bank_Transaction_Id: "",
    Bank_Allocation_Status: "",
    Bank_Reference_No: "",
    Receivable_Amount: ""
  });

  const [isSearchPerformed, setIsSearchPerformed] = useState(false);
  const [isClearPerformed, setIsClearPerformed] = useState(false);
  const [isStatusDeSelected, setIsStatusDeSelected] = useState(false);

  //For pagination
  const [paginationCount, setPaginationCount] = useState(0);
  const [pageState, setPageState] = useState({
    isLoading: true,
    data: [],
    total: 0,
    page: 1,
    pageSize: 25,
  });

  const [openCommentsDialog, setOpenCommentsDialog] = useState(false);
  const [dialogCommentsValue, setDialogCommentsValue] = useState(null);

  const [shouldLoadData, setShouldLoadData] = useState(true);

  // skip 0 means page 1
  const currentSkipNumber = () => {
    return pageState?.page === 1
      ? 0
      : pageState?.page === 0
        ? pageState?.page
        : pageState?.page - 1;
  };

  const Container = {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: 0,
    height: "calc(100vh - 180px)",
    maxHeight: "calc(100vh - 180px)",
    overflow: "hidden",
  };

  // to clear search list if all filter fields are empty after search has been performed
  useEffect(() => {
    if (isSearchPerformed) {
      if (Object.values(searchFieldsPrams).every(value => !value) && fromDateValue === "" && toDateValue === "") {
        handleClearSearchList();
      }
    }
  }, [fromDateValue, toDateValue]);

  const handleCommentsOpenDialog = (currentRowCommentsData) => {
    setOpenCommentsDialog(true);
    setDialogCommentsValue(currentRowCommentsData);
  };

  const handleCloseDialogs = () => {
    setOpenCommentsDialog(false);
    setDialogCommentsValue(null);
  };

  const columns = [
    {
      field: "historical",
      headerName: "",
      width: 15,
      headerAlign: "center",
      renderCell: (params) => (
        <>
          {params?.row?.historical === true ? (
            <div className="cash-alloc-indicator historical"></div>
          ) : (
            <div className="cash-alloc-indicator non-historical"></div>
          )}
        </>
      ),
    },
    {
      field: "Real_Bank_Name",
      headerName: "Bank Name",
      width: 100,
      headerAlign: "center",
    },
    {
      field: "Bank_Transaction_Id",
      headerName: "TXN ID",
      width: 120,
      headerAlign: "center",
      renderCell: (params) => (
        <a
          href={`javascript:void(0)`}
          onClick={() =>
            handleActionButton(
              {
                ...params.row.bank_txn,
                Real_Bank_Name: params.row.Real_Bank_Name,
              },
              "VIEW"
            )
          }
          // target="_blank"
          // rel="noopener noreferrer"
          style={{ color: "blue", cursor: "pointer" }}
        >
          {params.value}
        </a>
      ),
    },
    {
      field: "Broker_Branch",
      headerName: "Broker Branch",
      width: 150,
      headerAlign: "center",
    },
    {
      field: "bank_curr",
      headerName: "Bank Currency",
      width: 120,
      headerAlign: "center",
    },
    {
      field: "Policy_Line_Ref",
      headerName: "Policy#",
      width: 120,
      headerAlign: "center",
      renderCell: (params) => (
        <a
          href={`javascript:void(0)`}
          onClick={() =>
            (window.location.href = `/cash-allocation?txn_id=${encodeURIComponent(params?.row?.Bank_Transaction_Id)}&policy_ref=${params?.row?.id}`)
          }
          rel="noopener noreferrer"
          role="button"
          style={{ color: "blue" }}
        >
          {params.value}
        </a>
      ),
    },
    {
      field: "receivable_amt",
      headerName: "Receivable Amount",
      width: 150,
      headerAlign: "center",
      renderCell: (params) => (numberFormatter(params.value ?? 0))
      // renderCell: (params) => (
      //   <p
      //   // href={`javascript:void(0)`}
      //   // onClick={() => console.log("fsf",params.row.bank_txn)}
      //   // onClick={() => handleActionButton(params.row.bank_txn, "VIEW")}
      //   // target="_blank"
      //   // rel="noopener noreferrer"
      //   // style={{ color: "blue" }}
      //   >
      //     {params.row.bank_txn.Receivable_Amount}
      //   </p>
      // ),

      // renderCell: (params) =>
      //   numberFormatter(params?.row?.bank_txn?.Receivable_Amount),
      // cellClassName: "amount-table-cell"
    },
    {
      field: "allocation_status",
      headerName: "Policy Status",
      width: 160,
      headerAlign: "center",
      // valueGetter: (params) => params?.row?.bank_txn?.transaction_status,
    },
    {
      field: "original_curr",
      headerName: "Original Currency",
      width: 120,
      headerAlign: "center",
    },
    // {
    //   field: "allocated_amt",
    //   headerName: "Allocated Amount",
    //   headerAlign: "center",
    //   width: 160,
    //   valueFormatter: (params) => {
    //     return numberFormatter(params.value)
    //   }
    // },
    {
      field: "XFIbatchno",
      headerName: "Batch Reference",
      width: 120,
      headerAlign: "center",
    },
    {
      field: "cashreference",
      headerName: "Cash Reference",
      headerAlign: "center",
      width: 120,
      valueGetter: (params) => params?.row?.cashreference,
      renderCell: (params) => <p>{params?.row?.cashreference ?? ""}</p>,
    },
    {
      field: "GXPbatchno",
      headerName: "GXB Reference",
      headerAlign: "center",
      width: 120,
    },
    {
      field: "allocation_date",
      headerName: "Allocation Date",
      width: 160,
      headerAlign: "center",
      // valueGetter: (params) => params?.row?.bank_txn?.assigned_date,
      valueFormatter: (params) => {
        return params?.value
          ? customDateFormat(params?.value)
          : "";
      },
    },
    {
      field: "assigned_date",
      headerName: "Assigned Date",
      width: 160,
      headerAlign: "center",
      valueGetter: (params) => params?.row?.policy_assign_date ?? params?.row?.bank_txn?.assigned_date,
      valueFormatter: (params) => {
        return params?.value
          ? customDateFormat(params?.value)
          : "";
      },
    },
    {
      field: "Assigned_User",
      headerName: "Assigned To",
      headerAlign: "center",
      width: 120,
      valueGetter: (params) => params?.row?.policy_handler,
      renderCell: (params) => {
        return <>{params?.row?.policy_handler ?? ""}</>;
      },
    },
    {
      field: "comment",
      headerName: "Comment",
      headerAlign: "center",
      width: 130,
      renderCell: (params) => (
        <>
          {params?.row?.comment ? (
            <>
              {params?.row?.comment?.substr(0, 10)}
              <MoreHorizIcon
                onClick={() => handleCommentsOpenDialog(params?.row?.comment)}
              />
            </>
          ) : (
            <>{""}</>
          )}
        </>
      ),
    },
  ];

  useEffect(() => {
    setPaginationCount(
      getPaginationCount(pageState?.total, pageState?.pageSize)
    );
  }, [pageState?.total]);

  const loadData = async () => {
    try {
      setPageState((old) => ({
        ...old,
        isLoading: true,
      }));

      let queryParams = `skip=${currentSkipNumber()}&pageSize=${pageState?.pageSize
        }`;

      if (isSearchPerformed) {
        const getSearchQueryParam = searchQueryParams();
        if (getSearchQueryParam) {
          queryParams = `${queryParams}${getSearchQueryParam}`;
        }
      } else {
        // If we get information while performing route navigation
        if (!isClearPerformed) {
          let allocated = location?.state?.allocated || "";
          if (allocated) {
            queryParams = `${queryParams}&allocated=${allocated}`;
          }
          const policyNo = new URLSearchParams(search).get("policyNo");
          if (policyNo) {
            queryParams = `${queryParams}&policyNumber=${policyNo}`;
            setSearchFieldsPrams({
              ...searchFieldsPrams,
              Bank_Policy_No: policyNo,
            });
          }
        }
      }

      const response = await instance.get(`${getCashTracker}?${queryParams}`);

      setPageState((old) => ({
        ...old,
        isLoading: false,
      }));

      if (response.status === 200) {
        setPageState((old) => ({
          ...old,
          total: response?.data?.count,
          data: response?.data?.data ?? [],
        }));
        setPaginationCount(
          Math.floor(response?.data?.count / pageState?.pageSize)
        );
      } else {
        setPageState((old) => ({
          ...old,
          total: response?.data?.count,
          data: [],
        }));
        setPaginationCount(0);
      }
    } catch (err) {
      setPageState((old) => ({
        ...old,
        isLoading: false,
      }));
      setPaginationCount(0);
      console.error("err", err);
    }
  };

  const handleCashTrackerFieldsInputChange = (name, value, reason) => {
    setSearchFieldsPrams({
      ...searchFieldsPrams,
      [name]: value?.trim(),
    });
    setIsStatusDeSelected(false);
    if (reason == "clear") {
      setSearchFieldsPrams({
        ...searchFieldsPrams,
        Bank_Allocation_Status: "",
      });
      setIsStatusDeSelected(true);
    }

    // to clear search list if all filter fields are empty after search has been performed
    if (isSearchPerformed && !value) {
      const searchFields = searchFieldsPrams;
      delete searchFields[name];
      if (Object.values(searchFields).every(value => !value) && fromDateValue === "" && toDateValue === "") {
        handleClearSearchList();
      }
    }
  };

  const handleEnter = (e) => {
    if (e.code === "Enter") {
      handleSearchBankTransactionList();
    }
  };

  const searchQueryParams = () => {
    let getSearchQueryParams = "";

    const {
      Bank_Policy_No,
      Bank_Transaction_Id,
      Bank_Allocation_Status,
      Bank_Reference_No,
      Receivable_Amount
    } = searchFieldsPrams;

    // Handle single bank name selection (only first one is sent to backend)
    if (selectedBanks.length > 0) {
      getSearchQueryParams = `${getSearchQueryParams}&bankName=${selectedBanks[0]}`;
    }

    if (Bank_Policy_No) {
      getSearchQueryParams = `${getSearchQueryParams}&policyNumber=${Bank_Policy_No}`;
    }

    if (Bank_Transaction_Id) {
      getSearchQueryParams = `${getSearchQueryParams}&transactionId=${Bank_Transaction_Id}`;
    }

    if (Bank_Allocation_Status) {
      getSearchQueryParams = `${getSearchQueryParams}&status=${Bank_Allocation_Status}`;
    }

    if (Bank_Reference_No) {
      getSearchQueryParams = `${getSearchQueryParams}&searchKey=${Bank_Reference_No}`;
    }

    if (Receivable_Amount) {
      getSearchQueryParams = `${getSearchQueryParams}&receivableAmount=${Receivable_Amount}`
    }

    let formattedFromDateValue = "",
      formattedToDateValue = "";

    if (fromDateValue && toDateValue) {
      formattedFromDateValue = format(fromDateValue, "yyyy-MM-dd");
      formattedToDateValue = format(toDateValue, "yyyy-MM-dd");
      getSearchQueryParams = `${getSearchQueryParams}&fromAllocationDate=${formattedFromDateValue}&toAllocationDate=${formattedToDateValue}`;
    }

    return getSearchQueryParams;
  };

  const handleSearchBankTransactionList = async () => {
    try {
      let queryParams = `?skip=0&pageSize=${pageState?.pageSize}`;

      const getSearchQueryParam = searchQueryParams();
      if (getSearchQueryParam) {
        queryParams = `${queryParams}${getSearchQueryParam}`;
      }

      let allocated = location?.state?.allocated || "";
      if (allocated) {
        queryParams = `${queryParams}&allocated=${allocated}`;
      }

      if (
        location?.state?.fromDateValue &&
        location?.state?.toDateValue &&
        !queryParams.includes("fromAllocationDate")
      ) {
        let formattedFromDateValue = format(
          location?.state?.fromDateValue,
          "yyyy-MM-dd"
        );
        let formattedToDateValue = format(
          location?.state?.toDateValue,
          "yyyy-MM-dd"
        );
        queryParams = `${queryParams}&fromAllocationDate=${formattedFromDateValue}&toAllocationDate=${formattedToDateValue}`;
      }

      // set loading indicator
      setPageState((old) => ({
        ...old,
        isLoading: true,
      }));

      const response = await instance.get(`${getCashTracker}${queryParams}`);
      {
        const data = response.data;

        const secdata = data.summary;
        if (secdata !== null) {
          setTotalTransactionAmount(true);
        }

        // setTotalPremiumDueAmount(secdata.total_premium_due_amt);
        setTotalreceivableAmount(secdata.total_receivable_amount);
        setTotalAllocatedAmount(secdata.allocated_amount);
        setBankTxnAmount(secdata.rec_amt);
        setOutstandingAmount(secdata.outstanding_amt);
        setReceivableAmount(secdata.receivable_amount);
        setVariance(secdata.unallocated_amount);
      }
      setPageState((old) => ({
        ...old,
        isLoading: false,
      }));

      if (response.status === 200) {
        setPageState((old) => ({
          ...old,
          total: response?.data?.count,
          data: response?.data?.data ?? [],
          page: 1,
        }));
        setIsSearchPerformed(true);
        setIsClearPerformed(false);
      } else {
        setPageState((old) => ({
          ...old,
          total: response?.data?.count,
          data: [],
        }));
        setPaginationCount(0);
      }
    } catch (error) {
      setPaginationCount(0);
      setPageState((old) => ({
        ...old,
        isLoading: false,
      }));
    }
  };

  const isFilterBtnDisable = () => {
    let disabled = true;
    const {
      Bank_Policy_No,
      Bank_Transaction_Id,
      Bank_Allocation_Status,
      Bank_Reference_No,
      Receivable_Amount
    } = searchFieldsPrams;
    if (
      selectedBanks.length > 0 ||
      Bank_Policy_No !== "" ||
      Bank_Transaction_Id !== "" ||
      Bank_Allocation_Status !== "" ||
      Bank_Reference_No !== "" ||
      fromDateValue !== "" ||
      toDateValue !== "" ||
      Receivable_Amount !== ""
    ) {
      disabled = false;
    }

    return disabled;
  };

  const handleClearSearchList = async () => {
    // Clear all filter states
    setSelectedBanks([]);
    setBankNameSearch("");
    setIsClearPerformed(true);
    setIsSearchPerformed(false);
    setTotalTransactionAmount(false);
    // clear fields
    setSearchFieldsPrams({
      Bank_Name: "",
      Bank_Policy_No: "",
      Bank_Transaction_Id: "",
      Bank_Allocation_Status: "",
      Bank_Reference_No: "",
      Receivable_Amount: ""
    });
    getBankAccountsList("");
    setFromDateValue("");
    setToDateValue("");
    setShouldLoadData(true);
  };

  const handleDownload = async () => {
    setIsDownloadInProgress(true);
    try {
      instance
        .get(`${getCashTrackerReport}`, { responseType: "blob" })
        .then((response) => {
          const url = URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = url;
          const fileName = `Cash Tracker ${format(new Date(), "dd-MM-yyyy")}`;
          link.setAttribute("download", `${fileName}.xlsx`);
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
          setIsDownloadInProgress(false);
          commonToast("success", "File has been downloaded successfully");
        })
        .catch((err) => {
          setIsDownloadInProgress(false);
          commonToast("error", "File could not be downloaded");
        });
    } catch (error) {
      setIsDownloadInProgress(false);
      commonToast("error", "File could not be downloaded");
    }
  };

  const [isBankNameSelected, setIsBankNameSelected] = useState(false);

  // Handler for Bank Name Dropdown
  const handleBankNameDropdownChange = (name, value, reason) => {
    // This function is kept for backward compatibility but may not be used with CommonFilterSidebar
    if (reason === "clear") {
      setIsBankNameSelected(false);
      setSearchFieldsPrams((prev) => ({
        ...prev,
        [name]: value,
      }));

      // to clear search list if all filter fields are empty after search has been performed
      if (isSearchPerformed && !value) {
        const searchFields = searchFieldsPrams;
        delete searchFields[name];
        if (Object.values(searchFields).every(value => !value) && fromDateValue === "" && toDateValue === "") {
          handleClearSearchList();
        }
      }
    } else {
      setIsBankNameSelected(true);
      setSearchFieldsPrams((prev) => ({ ...prev, [name]: value }));
    }
  };

  const [banksList, setBanksList] = useState([]);
  const [selectedBankAccount, setSelectedBankAccount] = useState("");

  // Filter sidebar states
  const [filterSidebarOpen, setFilterSidebarOpen] = useState(true);
  const [bankNameSearch, setBankNameSearch] = useState("");
  const [selectedBanks, setSelectedBanks] = useState([]);

  const getBanksList = async () => {
    const response = await instance.get("documents/get_all_unique_bank_names/");
    setBanksList(response?.data?.bank_names);
  };

  const getBankAccountsList = async (value) => {
    const response = await instance.get(
      `documents/get_all_unique_account_numbers_by_bank_name/?bank_name=${value}`
    );
    setSelectedBankAccount(response?.data?.account_numbers);
  };

  // Handlers for checkbox filters - Single selection enforced
  const handleBankCheckboxChange = (bankName) => {
    setSelectedBanks((prev) => {
      if (prev.includes(bankName)) {
        // Deselect if already selected
        return prev.filter((b) => b !== bankName);
      } else {
        // Replace previous selection with new one (single selection)
        return [bankName];
      }
    });
  };

  const handleClearBankSearch = () => {
    setBankNameSearch("");
    setSelectedBanks([]);
  };

  // Update account list when selected banks change
  useEffect(() => {
    if (selectedBanks.length > 0) {
      getBankAccountsList(selectedBanks[0]);
    } else {
      getBankAccountsList("");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedBanks]);

  useEffect(() => {
    getBanksList();
    getBankAccountsList("");
  }, []);

  useEffect(() => {
    // Fetch Banks List
    dispatch(getAccountsList());
    // Fetch Broker branches
    dispatch(getBrokerBranchesList());
    // Fetch Currency Details
    dispatch(getCurrencyList());

    // load data
    if (shouldLoadData) {
      loadData();
      setShouldLoadData(false);
    }
  }, [pageState?.pageSize, pageState?.page, shouldLoadData]);

  const handleActionButton = (currentRowData, currentTxnMode) => {
    setCurrentRow(currentRowData);
    setTxnMode(currentTxnMode);
    setIsOpenTxnDialog(true);
  };

  return (
    <div style={Container}>
      <Box
        sx={{
          "& .MuiCheckbox-root": {
            color: "#1672DE !important",
            "&.Mui-checked": {
              color: "#1672DE !important",
            },
            "&.MuiCheckbox-colorPrimary": {
              color: "#1672DE !important",
              "&.Mui-checked": {
                color: "#1672DE !important",
              },
            },
          },
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "row", height: "100%" }}>
          {/* Filter Sidebar */}
          <CommonFilterSidebar
            isOpen={filterSidebarOpen}
            filterConfigs={[
              {
                type: "bankName",
                label: "Bank Name",
                placeholder: "Search banks",
                searchValue: bankNameSearch,
                onSearchChange: setBankNameSearch,
                items: banksList || [],
                selectedItems: selectedBanks,
                onItemChange: handleBankCheckboxChange,
                onClear: handleClearBankSearch,
              },
              {
                type: "textInput",
                label: "Policy No",
                placeholder: "Enter policy number",
                value: searchFieldsPrams?.Bank_Policy_No ?? "",
                onChange: (value) => handleCashTrackerFieldsInputChange("Bank_Policy_No", value),
                onKeyUp: handleEnter,
              },
              {
                type: "textInput",
                label: "Transaction Id",
                placeholder: "Enter transaction ID",
                value: searchFieldsPrams?.Bank_Transaction_Id ?? "",
                onChange: (value) => handleCashTrackerFieldsInputChange("Bank_Transaction_Id", value),
                onKeyUp: handleEnter,
              },
              {
                type: "custom",
                label: "Status",
                content: (
                  <Box>
                    <Typography
                      sx={{
                        fontSize: "16px",
                        fontWeight: "600",
                        color: "#000",
                        marginBottom: "12px",
                      }}
                    >
                      Status
                    </Typography>
                    <CommonSelect
                      placeholder="Select Status"
                      value={searchFieldsPrams?.Bank_Allocation_Status ?? ""}
                      handleChange={(event, value, reason) =>
                        handleCashTrackerFieldsInputChange(
                          "Bank_Allocation_Status",
                          value,
                          reason,
                          event
                        )
                      }
                      options={
                        allocationStatusList?.map((option) => option?.label) || []
                      }
                    />
                  </Box>
                ),
              },
              {
                type: "textInput",
                label: "Reference No",
                placeholder: "Enter reference number",
                value: searchFieldsPrams?.Bank_Reference_No ?? "",
                onChange: (value) => handleCashTrackerFieldsInputChange("Bank_Reference_No", value),
                onKeyUp: handleEnter,
              },
              {
                type: "textInput",
                label: "Receivable Amount",
                placeholder: "Enter receivable amount",
                value: searchFieldsPrams?.Receivable_Amount ?? "",
                onChange: (value) => handleCashTrackerFieldsInputChange("Receivable_Amount", value),
                inputType: "number",
                onKeyUp: handleEnter,
              },
              {
                type: "dateRange",
                label: "Allocated Date",
                startDate: fromDateValue,
                setStartDate: setFromDateValue,
                endDate: toDateValue,
                setEndDate: setToDateValue,
                maxDate: new Date(),
                onKeyUp: handleEnter,
              },
            ]}
            onApplyFilters={handleSearchBankTransactionList}
            onClearFilters={handleClearSearchList}
            isLoading={pageState?.isLoading}
            isFilterDisabled={isFilterBtnDisable()}
          />

          {/* Main Content Area */}
          <Box className="main-content-area">
            <Box className="page-header-container">
              <Box sx={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                <Typography variant="h5" className="page-heading">
                  Cash Tracker
                </Typography>
                <Box sx={{ display: "flex", gap: "20px", mt: "10px" }}>
                  <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
                    <span
                      className="cash-alloc-indicator historical"
                      style={{ marginRight: "3px" }}
                    />
                    <Typography variant="body2">Historical</Typography>
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
                    <span
                      className="cash-alloc-indicator non-historical"
                      style={{ marginRight: "3px" }}
                    />
                    <Typography variant="body2">Non-Historical</Typography>
                  </Box>
                </Box>
              </Box>
              <Box sx={{ display: "flex", gap: "10px", alignItems: "center" }}>
                <CommonButton
                  text={isDownloadInProgress ? "Downloading" : "Download"}
                  hoverColor="#1565c0"
                  icon={<DownloadIcon />}
                  handleClick={handleDownload}
                  disabled={isDownloadInProgress}
                  sx={{
                    backgroundColor: "#1672DE !important",
                    color: "white !important",
                    borderRadius: "6px",
                    padding: "8px 20px",
                    fontWeight: "500",
                    "&:hover": {
                      backgroundColor: "#1565c0 !important",
                    },
                  }}
                />
                <IconButton
                  onClick={() => setFilterSidebarOpen(!filterSidebarOpen)}
                  className="filter-toggle-button"
                >
                  <FilterListIcon />
                </IconButton>
              </Box>
            </Box>

            {totalTransactionAmount && (
              <Box sx={{ mt: 2, mb: 2, p: 2, backgroundColor: "#f8f9fa", borderRadius: "8px" }}>
                <Table aria-label="summary table" style={{ width: "100%" }}>
                  <TableHead>
                    <TableRow>
                      <TableCell style={{ border: "none", padding: "8px" }} align="center">
                        <b>Bank Txn Amount</b>
                      </TableCell>
                      <TableCell style={{ border: "none", padding: "8px" }} align="center">
                        <b>Total Premium Due Amount</b>
                      </TableCell>
                      <TableCell style={{ border: "none", padding: "8px" }} align="center">
                        <b>Total Receivable Amount</b>
                      </TableCell>
                      <TableCell style={{ border: "none", padding: "8px" }} align="center">
                        <b>Total Allocated Amount</b>
                      </TableCell>
                      <TableCell style={{ border: "none", padding: "8px" }} align="center">
                        <b>Outstanding Amount</b>
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow>
                      <TableCell style={{ border: "none", padding: "8px" }} align="center">
                        {numberFormatter(bankTxnAmount)}
                      </TableCell>
                      <TableCell style={{ border: "none", padding: "8px" }} align="center">
                        {numberFormatter(totalPremiumDueAmount)}
                      </TableCell>
                      <TableCell style={{ border: "none", padding: "8px" }} align="center">
                        {numberFormatter(totalreceivableAmount)}
                      </TableCell>
                      <TableCell style={{ border: "none", padding: "8px" }} align="center">
                        {numberFormatter(receivableAmount)}
                      </TableCell>
                      <TableCell style={{ border: "none", padding: "8px" }} align="center">
                        {numberFormatter(totalAllocatedAmount)}
                      </TableCell>
                      <TableCell style={{ border: "none", padding: "8px" }} align="center">
                        {numberFormatter(outstandingAmount)}
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </Box>
            )}

            <Box
              sx={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                minHeight: 0,
                position: "relative",
                backgroundColor: "#ffffff",
                borderRadius: "12px",
                boxShadow: "0 4px 16px rgba(0,0,0,0.08)",
                overflow: "visible",
                transition: "all 0.3s ease",
                border: "1px solid #e8eaf0",
                paddingBottom: "10px",
                "&:hover": {
                  boxShadow: "0 6px 20px rgba(0,0,0,0.12)",
                },
              }}
            >
              <DataGrid
                className={classes.pagination}
                loading={pageState?.isLoading}
                rows={pageState?.data ?? []}
                columns={columns}
                rowCount={pageState?.total}
                keepNonExistentRowsSelected
                disableSelectionOnClick
                pagination
                paginationMode="server"
                getRowId={(row) => row?.id}
                page={pageState.page - 1}
                pageSize={pageState?.pageSize ?? 25}
                rowsPerPageOptions={[10, 25, 50, 100]}
                onPageSizeChange={(newPageSize) => {
                  return setPageState((old) => {
                    setPaginationCount(
                      getPaginationCount(pageState?.total, newPageSize)
                    );
                    return { ...old, pageSize: newPageSize, page: 1 };
                  });
                }}
                sx={{
                  border: "none",
                  flex: 1,
                  minHeight: 0,
                  "& .MuiDataGrid-root": {
                    border: "none",
                    height: "100%",
                  },
                  "& .MuiDataGrid-main": {
                    height: "100%",
                    "&::-webkit-scrollbar": {
                      width: "8px",
                      height: "8px",
                    },
                    "&::-webkit-scrollbar-track": {
                      background: "#f1f1f1",
                      borderRadius: "10px",
                    },
                    "&::-webkit-scrollbar-thumb": {
                      background: "#1672DE",
                      borderRadius: "10px",
                      "&:hover": {
                        background: "#1565c0",
                      },
                    },
                  },
                  "& .MuiDataGrid-columnHeaders": {
                    backgroundColor: "#f8f9fa",
                    borderBottom: "2px solid #e0e0e0",
                    minHeight: "52px !important",
                    maxHeight: "52px !important",
                  },
                  "& .MuiDataGrid-columnHeader": {
                    backgroundColor: "transparent",
                    fontWeight: "600",
                    color: "#1672DE",
                    fontSize: "14px",
                    padding: "12px 16px",
                    borderBottom: "none",
                    overflow: "visible",
                    "&:focus": {
                      outline: "none",
                    },
                    "&:focus-within": {
                      outline: "none",
                    },
                    "& .MuiDataGrid-columnHeaderTitle": {
                      fontWeight: "600",
                      fontSize: "14px",
                      overflow: "visible",
                      textOverflow: "clip",
                      whiteSpace: "normal",
                      lineHeight: "1.4",
                      width: "100%",
                    },
                    "& .MuiDataGrid-sortIcon": {
                      color: "#1672DE",
                    },
                    "& .MuiDataGrid-menuIcon": {
                      color: "#1672DE",
                    },
                  },
                  "& .MuiDataGrid-row": {
                    transition: "all 0.2s ease",
                    borderBottom: "1px solid #f0f0f0",
                    "&:hover": {
                      backgroundColor: "rgba(22, 114, 222, 0.04)",
                      boxShadow: "0 2px 4px rgba(0,0,0,0.02)",
                    },
                    "&:nth-of-type(even)": {
                      backgroundColor: "#fafafa",
                      "&:hover": {
                        backgroundColor: "rgba(22, 114, 222, 0.04)",
                      },
                    },
                  },
                  "& .MuiDataGrid-cell": {
                    borderBottom: "1px solid #f0f0f0",
                    padding: "12px 16px",
                    fontSize: "13px",
                    color: "#333",
                    display: "flex",
                    alignItems: "center",
                    "&:focus": {
                      outline: "none",
                    },
                    "&:focus-within": {
                      outline: "none",
                    },
                  },
                  "& .MuiDataGrid-virtualScroller": {
                    "&::-webkit-scrollbar": {
                      width: "8px",
                      height: "8px",
                    },
                    "&::-webkit-scrollbar-track": {
                      background: "#f1f1f1",
                      borderRadius: "10px",
                    },
                    "&::-webkit-scrollbar-thumb": {
                      background: "#1672DE",
                      borderRadius: "10px",
                      "&:hover": {
                        background: "#1565c0",
                      },
                    },
                  },
                  "& .MuiDataGrid-footerContainer": {
                    borderTop: "2px solid #e0e0e0",
                    backgroundColor: "#f8f9fa",
                    minHeight: "48px",
                    maxHeight: "48px",
                    paddingBottom: "8px",
                    paddingTop: "8px",
                    paddingLeft: "16px",
                    paddingRight: "16px",
                    position: "relative",
                    zIndex: 1,
                  },
                  "& .MuiDataGrid-toolbarContainer": {
                    padding: "12px 16px",
                    backgroundColor: "#f8f9fa",
                    borderBottom: "1px solid #e0e0e0",
                  },
                  "& .MuiDataGrid-loadingOverlay": {
                    backgroundColor: "rgba(255, 255, 255, 0.8)",
                  },
                }}
                components={{
                  Toolbar: GridToolbarContainer,
                }}
              />
              <Stack
                sx={{
                  position: "absolute",
                  bottom: "16px",
                  right: "20px",
                  zIndex: 10,
                  backgroundColor: "#f8f9fa",
                  padding: "4px 8px",
                  borderRadius: "4px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                }}
              >
                <CommonPaginationContainer
                  count={paginationCount + 1}
                  pageState={pageState}
                  setPageState={setPageState}
                  setShouldLoadData={setShouldLoadData}
                />
              </Stack>
            </Box>
          </Box>
        </Box>
      </Box>
      {isOpenTxnDialog && (
        <ViewAndEditBankTransaction
          isOpenTxnDialog={isOpenTxnDialog}
          setIsOpenTxnDialog={setIsOpenTxnDialog}
          txnMode={txnMode}
          txnData={currentRow}
          navigatedFrom={NAVIGATION_PAGE_NAME.CASH_TRACKER}
        />
      )}

      <Dialog
        open={openCommentsDialog}
        onClose={handleCloseDialogs}
        disableBackdropClick
      >
        <DialogTitle id="alert-dialog-title" sx={{ cursor: "default" }}>
          Comment
          <IconButton
            aria-label="close"
            onClick={() => {
              handleCloseDialogs();
            }}
            style={{ position: "absolute", right: 12, top: 12 }}
          >
            <CloseIcon className="CloseIconStyle" />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ overflow: "hidden" }}>
          <TextareaAutosize
            minRows={5}
            value={dialogCommentsValue}
            className=""
            disabled={true}
            style={{ width: "350px", minWidth: "350px" }}
          />
        </DialogContent>
      </Dialog>
    </div>
  );
}
